import {
	GET_COLLABORATORS_WORK_CENTER_SUCCESS,
	GET_COLLABORATORS,
	GET_COLLABORATORS_WORK_CENTER,
} from '../../../constants';

export const getCollaboratorsWorkCenterReducer = (state, actions) => {
	switch (actions.type) {
		case GET_COLLABORATORS_WORK_CENTER:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_COLLABORATORS:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_COLLABORATORS_WORK_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				collaborators: actions.payload,
			};
		default:
			return state;
	}
};
